import React from 'react';

import { ALLOWED_ROLES } from '@src/packages/utils/access';

import { PATHS } from './constants';

const CostCenters = React.lazy(() => import('./screens/CostCenters'));

const routes = [
  {
    component: CostCenters,
    path: PATHS.BASE_URL,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.COST_CENTERS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
];

export default routes;
